import { getStorage } from "@api/utilities";
import useAuth from "@hooks/Auth/useAuth";
import { StorageInfoResponse } from "@models/utilities";
import { useQuery } from "@tanstack/react-query";

export default function useGetStorage() {
  const { accessToken } = useAuth();

  const query = useQuery<StorageInfoResponse>({
    queryKey: ['Storage'],
    queryFn: async () => {
      const res = await getStorage({ accessToken });
      if (res.status === 200 || res.status === 201) {
        return res.data;
      } else {
        throw res.status;
      }
    },
    refetchOnWindowFocus: true,
    staleTime: 0,
  });

  return query;
}
